



























































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  handleSubmit() {
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        const res = await this.$store.dispatch('stadium/editGround', {
          id: this.editId,
          ...values,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success('修改成功');
          this.handleCancel();
        } else {
          this.$message.error('修改失败');
        }
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch('stadium/getGround', {
      id: this.editId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
